module.exports = __webpack_public_path__ + "static/media/calendar.50070f67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar.svg
// module id = 903
// module chunks = 33